/**
 * Modify links on page load.
 */
H_Tools?.links?.modifyLinks(document);
